/*@ngInject*/
const ProposalActionsMediator = function (proposalActionRepository) {

    this.copyProposal = function (proposalId, quotesList) {
        return proposalActionRepository.copyProposal(proposalId, quotesList);
    };

    this.modifyProposal = function (quoteId) {
        return proposalActionRepository.modifyProposal(quoteId);
    };

    this.deleteProposal = function (proposalId) {
        return proposalActionRepository.deleteProposal(proposalId);
    };

    this.createProposal = function (submissionId, productId) {
        return proposalActionRepository.createProposal(submissionId, productId);
    };

    this.createQuote = function (submissionId, productId, productTemplateId) {
        return proposalActionRepository.createQuote(submissionId, productId, productTemplateId);
    };

    this.addSectionFromDocument = function (proposalId, attachmentId, displayLabel, sectionType) {
        return proposalActionRepository.addSectionFromDocument(proposalId, attachmentId, displayLabel, sectionType);
    };

    this.addSectionFromFile = function (proposalId, data, file) {
        return proposalActionRepository.uploadSectionFromFile(proposalId, data, file);
    };

    this.bindProposal = function (proposalId, quoteId) {
        return proposalActionRepository.bindProposal(proposalId, quoteId);
    };

    this.addSection = function (proposalId, sectionTemplateId, sectionType) {
        return proposalActionRepository.addSection(proposalId, sectionTemplateId, sectionType);
    };

    this.beginBinding = function (proposalId, quoteIds) {
        return proposalActionRepository.beginBinding(proposalId, quoteIds);
    };

    this.requestBinding = function (proposalId) {
        return proposalActionRepository.requestBindingByProposalId(proposalId);
    };

    this.requestToBindFromSent = function (quoteIds) {
        return proposalActionRepository.requestBinding(quoteIds);
    };

    this.bindProposalFromSent = function (proposalId, quoteIds) {
        return proposalActionRepository.bindProposal(proposalId, quoteIds);
    };

    this.deleteSection = function (sectionTemplateId, invalidateProposalDocument) {
        return proposalActionRepository.deleteSection(sectionTemplateId, invalidateProposalDocument);
    };

    this.generateQuotes = function (proposalId) {
        return proposalActionRepository.generateQuotes(proposalId);
    };

    this.generateBinder = function (proposalId) {
        return proposalActionRepository.generateBinder(proposalId);
    };

    this.declineToBind = function (proposalId, reason, detail) {
        return proposalActionRepository.declineToBind(proposalId, reason, detail);
    };

    this.declineToBindFromSent = function (quoteIds, reason, detail) {
        return proposalActionRepository.declineToBindFromSent(quoteIds, reason, detail);
    };
};

angular.module('gw-um-submission')
    .service('proposalActionsMediator', ProposalActionsMediator);
